import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {BulletList, Button, PageContainer, PageSubTitle, PageTitle} from '../Common/PageComponents';
import {fetchProducts} from '../../actions/purchase.actions';
import {ProductsTable} from './ProductsComponents';
import ToggleTabs, {Tab} from '../Common/ToggleTabs';
import {LolIcon, ValorantIcon} from '../Common/GameIcons';

class ProductsGuide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedGame: 'lol',
    };
  }
  componentDidMount() {
    this.props.dispatch(fetchProducts());
  }

  clickTab(selectedGame) {
    this.setState({selectedGame});
  }

  render() {
    const isSelectedLol = this.state.selectedGame === 'lol';
    const isSelectedValorant = this.state.selectedGame === 'valorant';
    return (
      <PageContainer>
        <PageTitle title="PC방 상품안내">
          Home &gt; 상품안내 &amp; 결제 &amp; 쿠폰 &gt; <strong> PC방 상품안내</strong>
        </PageTitle>

        <PageSubTitle title="프리미엄 PC방 혜택 안내" />
        <ToggleTabs theme={'blue'}>
          <Tab onClick={() => this.clickTab('lol')} active={isSelectedLol}>
            <LolIcon /> 리그 오브 레전드
          </Tab>
          <Tab onClick={() => this.clickTab('valorant')} active={isSelectedValorant}>
            <ValorantIcon /> 발로란트
          </Tab>
        </ToggleTabs>
        <div className="products-guide-benefit">
          <img
            src="/image/guide/lol.png"
            alt="리그 오브 레전드 PC방 혜택"
            style={{display: isSelectedLol ? 'block' : 'none'}}
          />
          <img
            src="/image/guide/valorant.png"
            alt="발로란트 PC방 혜택"
            style={{display: isSelectedValorant ? 'block' : 'none'}}
          />
        </div>

        <PageSubTitle title="요금 안내" />
        <p>
          PC방 사업자는 라이엇 서비스를 제공받기 위해서 포인트 구매가 필요합니다. <br />
          포인트는 라이엇 PC방 사이트에서 사용하실 수 있는 모든 게임에서 사용할 수 있는 통합 포인트로, 첫 구매 시 사업장
          내 등록하신 각 IP에 대하여 자사가 서비스중인 모든 게임에 대해 가입된 것으로 간주, 각 게임의 플레이 권한 및
          프리미엄 PC방 혜택이 부여된 상태로 시작됩니다.
        </p>
        <ProductsTable products={this.props.products} style={{margin: '20px 0'}} />
        <p>
          <strong>포인트 (pt)란?</strong>
          <BulletList className="bullet-list">
            <ul>
              <li>
                라이엇 pc방 사이트에서 이용할 수 있는 통합 상품으로, 서비스 중인 모든 게임은 포인트 충전 후 이용하실 수
                있습니다.
              </li>
              <li>포인트 별 이용 시간은 게임별로 상이합니다.</li>
              <li>결제 수단: 신용카드, 계좌이체, 가상계좌(일반 결제 전용)</li>
            </ul>
          </BulletList>
        </p>
        <div style={{textAlign: 'center', marginTop: 20}}>
          <Link to="/products/purchase">
            <Button>구매하기</Button>
          </Link>
        </div>
      </PageContainer>
    );
  }
}

const stateToProps = state => {
  return {
    products: state.purchase.products,
  };
};

export default connect(stateToProps)(ProductsGuide);
